import { useState, useEffect } from "react";
import { Box, Button, Typography, Grid } from "@material-ui/core";
import { Helmet } from "react-helmet";
import Axios from "axios";

import { Loading } from "../../components/shared/loading";
import { EditorCkMain } from "../../components/CkEditor";
import { useAdminStyles } from "../../components/admin/adminStyles";
import { AdminPageHeader } from "../../components/admin/AdminPageHeader";
import { useToast } from "../../components/shared/Toast";

import SaveIcon from "@material-ui/icons/Save";
import RefreshIcon from "@material-ui/icons/Refresh";

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";

export const UpdateAboutUs = () => {
  const classes = useAdminStyles();
  const toast = useToast();

  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [updatingSitemap, setUpdatingSitemap] = useState(false);

  useEffect(() => {
    Axios.get("/api/select_aboutus", { headers: { headKey: headKey } }).then(
      (res) => {
        if (res.status === 200 && res.data.data) {
          setContent(res.data.data.description || "");
        }
        setLoading(false);
      }
    );
  }, []);

  const updateSitemap = async () => {
    setUpdatingSitemap(true);
    Axios.get("/api/update-sitemap")
      .then((res) => {
        setUpdatingSitemap(false);
        if (res.data.status) {
          toast.success("Sitemap updated successfully");
        } else {
          toast.error("Failed to update sitemap");
        }
      })
      .catch(() => {
        setUpdatingSitemap(false);
        toast.error("Network error. Please try again.");
      });
  };

  const onSubmit = async () => {
    if (!content || !content.trim()) {
      toast.error("Please enter the About Us content.");
      return;
    }
    setSubmitting(true);
    const formdata = new FormData();
    formdata.append("description", content);
    Axios.post("/api/update_aboutus", formdata, {
      headers: { headKey: headKey },
    })
      .then((res) => {
        setSubmitting(false);
        if (res.data.status) {
          toast.success(res.data.msg || "About Us updated");
        } else {
          toast.error(res.data.msg || "Something went wrong. Try again.");
        }
      })
      .catch(() => {
        setSubmitting(false);
        toast.error("Network error. Please try again.");
      });
  };

  if (loading) return <Loading />;

  return (
    <div>
      <Helmet>
        <title>About Us - Admin | Arawinz Soft Solutions</title>
      </Helmet>

      <AdminPageHeader
        eyebrow="Content"
        title="About Us"
        subtitle="Edit the About Us content shown on the public site."
      />

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography className={classes.sectionTitle}>About content</Typography>
          <EditorCkMain desc={content} setDescr={(e) => setContent(e)} />
        </Grid>

        <Grid item xs={12}>
          <Box className={classes.formFooter} style={{ marginTop: 0, paddingTop: 18 }}>
            <Button
              onClick={onSubmit}
              disabled={submitting}
              className={classes.primaryBtn}
              startIcon={!submitting && <SaveIcon />}
            >
              {submitting ? "Saving..." : "Save About Us"}
            </Button>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Typography className={classes.sectionTitle} style={{ marginTop: 24 }}>
            Sitemap
          </Typography>
          <Typography style={{ fontSize: "0.82rem", color: "#6b7280", marginBottom: 14 }}>
            Regenerate the sitemap.xml after publishing major content changes.
          </Typography>
          <Button
            onClick={updateSitemap}
            disabled={updatingSitemap}
            className={classes.secondaryBtn}
            startIcon={<RefreshIcon />}
          >
            {updatingSitemap ? "Updating..." : "Update Sitemap"}
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};
